// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Drag & Drop Overlay */
.drag-drop-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.498039);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  pointer-events: none;
}

.drag-drop-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-radius: 10px;
  border: 1px solid white;
  height: 400px;
  width: 400px;
}

.drag-drop-icon {
  font-size: 80px;
  position: relative;
  display: inline-block;
  color: white;
}

.drag-drop-text {
  color: white;
  font-size: 26px;
  font-family: 'Roboto', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/DragDropOverlay/DragDropOverlay.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC","sourcesContent":["/* Drag & Drop Overlay */\n.drag-drop-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.498039);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  pointer-events: none;\n}\n\n.drag-drop-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  border-radius: 10px;\n  border: 1px solid white;\n  height: 400px;\n  width: 400px;\n}\n\n.drag-drop-icon {\n  font-size: 80px;\n  position: relative;\n  display: inline-block;\n  color: white;\n}\n\n.drag-drop-text {\n  color: white;\n  font-size: 26px;\n  font-family: 'Roboto', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
